// Tabelas legíveis no telemóvel: uma <table className="table-cards"> passa a
// mostrar cada linha como um cartão em ecrãs estreitos (CSS em styles/ui.css).
// Aqui só se põe em cada célula o rótulo da sua coluna (data-label), lido do
// cabeçalho — também quando a tabela é actualizada.
//
// - Uma célula que já traga data-label no JSX mantém o seu.
// - A coluna de acções ("Acções"/"Ações") vai para o fundo do cartão.
// - A 1.ª coluna com cabeçalho é o título do cartão.
// - Células que ocupam a linha toda (ex.: "Sem dados") ficam sem rótulo.

const ACTIONS_RE = /^a[cç]?[cç][õo]es$/i;

function headerLabels(table) {
  const labels = [];
  const headRow = table.tHead?.rows?.[table.tHead.rows.length - 1];
  if (!headRow) return labels;
  for (const th of headRow.cells) {
    const text = th.dataset.label ?? th.textContent.replace(/\s+/g, " ").trim();
    for (let i = 0; i < (th.colSpan || 1); i += 1) labels.push(text);
  }
  return labels;
}

function labelTable(table) {
  const labels = headerLabels(table);
  if (!labels.length) return;
  // Título do cartão: 1.ª coluna com cabeçalho (ex.: "Nome" quando a 1.ª é a foto).
  const titleCol = Math.max(0, labels.findIndex((l) => l));
  for (const body of table.tBodies) {
    for (const row of body.rows) {
      let col = 0;
      for (const cell of row.cells) {
        const span = cell.colSpan || 1;
        if (span >= labels.length) {
          cell.setAttribute("data-card", "full");
        } else if (!cell.hasAttribute("data-label-manual")) {
          const label = labels[col] || "";
          if (cell.getAttribute("data-label") !== label) cell.setAttribute("data-label", label);
          // Atributos (e não classes): o React reescreve "class" ao voltar a desenhar a célula.
          const role = ACTIONS_RE.test(label) ? "actions" : col === titleCol ? "title" : "";
          if ((cell.getAttribute("data-card") || "") !== role) {
            if (role) cell.setAttribute("data-card", role);
            else cell.removeAttribute("data-card");
          }
        }
        col += span;
      }
    }
  }
}

let scheduled = false;
function relabelAll() {
  scheduled = false;
  document.querySelectorAll("table.table-cards").forEach(labelTable);
}

/** Liga o observador (uma vez, no arranque da aplicação). */
export function installTableCards() {
  if (typeof document === "undefined" || typeof MutationObserver === "undefined") return;
  const schedule = () => {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(relabelAll);
  };
  new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true });
  schedule();
}

export { labelTable };
